__turbopack_context__.v({
  "questionnaireNavigationItem": "QuestionnaireNavigationItem-module__HxNPOa__questionnaireNavigationItem",
  "questionnaireNavigationItemActive": "QuestionnaireNavigationItem-module__HxNPOa__questionnaireNavigationItemActive",
  "questionnaireNavigationItemCompleted": "QuestionnaireNavigationItem-module__HxNPOa__questionnaireNavigationItemCompleted",
  "questionnaireNavigationItemError": "QuestionnaireNavigationItem-module__HxNPOa__questionnaireNavigationItemError",
  "questionnaireNavigationItemIncomplete": "QuestionnaireNavigationItem-module__HxNPOa__questionnaireNavigationItemIncomplete",
  "questionnaireNavigationItem__icon": "QuestionnaireNavigationItem-module__HxNPOa__questionnaireNavigationItem__icon",
});
